import { Component, Prop } from 'vue-property-decorator'
import ClvrComponent from '../../../../../system/vue/Core/ClvrComponent'
import { KhDate, IntervalTime, KhText, KhTimeClock } from '@internal-libraries/kheops-ui-lib'

@Component({
    components: {
        KhText,
        KhTimeClock,
    },
})
export default class ClvrScreenControlHeader extends ClvrComponent {
    @Prop({ type: String, default: '' })
    public title!: string
    @Prop({ type: String, default: '' })
    public subTitle!: string
    @Prop({ type: Number })
    public currentPage?: number
    @Prop({ type: Number })
    public lastPage?: number
    @Prop({ type: Date })
    public date?: Date
    @Prop({ type: String })
    public room?: string

    private readonly DATE_FORMAT = 'EEEE dd LLLL yyyy'

    public get isCurrentDay(): boolean {
        return this.date?.toDateString() === new Date().toDateString() || !this.date
    }

    public get formattedDate(): string {
        return new KhDate(this.date).format(this.DATE_FORMAT, this.$i18n.dateLocale)
    }

    public get IntervalTime(): typeof IntervalTime {
        return IntervalTime
    }

    public get pagination(): string {
        return `(${this.$t('clevehr:Page')} ${this.currentPage} / ${this.lastPage})`
    }
}
